import ServiciosService, { EstadoServicio, TipoServicio } from '../ServiciosService';
import TabGensService, { TabGen } from '../TabGensService';

export interface AdminData {
  datosGenerales: DatosGenerales;
}

export interface DatosGenerales {
  tiposDeServicio: TipoServicio[];
  estadosDeServicio: EstadoServicio[];
  tabGens: TabGen;
}

const fetchAdminData = async (): Promise<AdminData> => {
  const tiposDeServicio = await ServiciosService.fetchTiposDeServicio();
  const estadosDeServicio = await ServiciosService.fetchEstadosDeServicio();
  const tabGens = await TabGensService.fetchAll();
  const result: AdminData = {
    datosGenerales: {
      tiposDeServicio,
      estadosDeServicio,
      tabGens
    }
  }
  return result;
}

export default {
  fetchAdminData
}
